"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectManager = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classes = require("../classes");
var _controllers = require("../controllers");
var _api = require("../api");
var ProjectManager = /*#__PURE__*/function () {
  function ProjectManager() {
    (0, _classCallCheck2["default"])(this, ProjectManager);
    this.project = new _classes.Project();
  }
  (0, _createClass2["default"])(ProjectManager, [{
    key: "getProject",
    value: function getProject() {
      return this.project;
    }
  }, {
    key: "save",
    value: function () {
      var _save = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this = this;
        var clone,
          isOffer,
          configJson,
          envWall,
          dataWall,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              clone = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              isOffer = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              configJson = _args.length > 2 ? _args[2] : undefined;
              envWall = _args.length > 3 ? _args[3] : undefined;
              dataWall = _args.length > 4 ? _args[4] : undefined;
              return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (isOffer) _this.project.isoffer = 1;
                var prj = _this.project;
                prj.envWall = envWall;
                prj.envWall.wallsVector = dataWall.wall;
                prj.envWall.windowInstance = dataWall.windowInstance;
                var encodePrj = prj.getJson();
                encodePrj.measures = configJson.measures;
                encodePrj.currency = configJson.currency;
                encodePrj.pricesIncrease = configJson.pricesIncrease === null || configJson.pricesIncrease === undefined ? 1 : configJson.pricesIncrease;
                _api.ProjectsAPI.saveProject(encodePrj, clone, function (json) {
                  if (json) {
                    _this.project.mergeJson(json);
                    resolve(json);
                  } else {
                    reject();
                  }
                });
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "loadPrj",
    value: function () {
      var _loadPrj = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(prjId) {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                _api.ProjectsAPI.getProject(prjId, function (json) {
                  if (json) {
                    _this2.emptyProject();
                    json.info = json.info !== null && json.info !== undefined ? json.info : '';
                    _this2.project.mergeJson(json);
                    _this2.project.isopen = true;
                    resolve(_this2.project);
                  } else {
                    reject();
                  }
                }, reject);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loadPrj(_x) {
        return _loadPrj.apply(this, arguments);
      }
      return loadPrj;
    }()
  }, {
    key: "setStatus",
    value: function setStatus(prjId, status) {
      var toShop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var toUser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var extraData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      return new _promise["default"](function (resolve, reject) {
        _api.ProjectsAPI.setstatus(prjId, status, toShop, toUser, extraData, function (json) {
          if (json) {
            resolve(json);
          } else {
            reject(new Error('Missing response'));
          }
        }, reject);
      });
    }
  }, {
    key: "emptyProject",
    value: function emptyProject() {
      var prj = new _classes.Project();
      (0, _assign["default"])(this.project, prj);
      this.project.isopen = false;
    }
  }, {
    key: "updateEvaluatorRule",
    value: function () {
      var _updateEvaluatorRule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(rowRuled) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.project.isProjectRow(rowRuled.getRow())) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", rowRuled.updateRule(this.project));
            case 4:
              return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                try {
                  rowRuled.overrideRule();
                } catch (e) {
                  reject(e);
                }
                resolve(rowRuled.getRow().rule);
              }));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateEvaluatorRule(_x2) {
        return _updateEvaluatorRule.apply(this, arguments);
      }
      return updateEvaluatorRule;
    }()
  }, {
    key: "updateRule",
    value: function () {
      var _updateRule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(row, rule, placerIndex) {
        var _this3 = this;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (_this3.project.isProjectRow(row)) {
                  _controllers.RowRule.updateRule(row, rule, placerIndex, _this3.project).then(resolve)["catch"](reject);
                } else {
                  try {
                    row.rule = rule;
                    row.reg = rule.reg;
                  } catch (e) {
                    reject(e);
                  }
                  resolve(rule);
                }
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function updateRule(_x3, _x4, _x5) {
        return _updateRule.apply(this, arguments);
      }
      return updateRule;
    }()
  }, {
    key: "setVariant",
    value: function () {
      var _setVariant = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(variant, rule, catalog) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", _controllers.RowRule.setVariant(variant, rule, catalog));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function setVariant(_x6, _x7, _x8) {
        return _setVariant.apply(this, arguments);
      }
      return setVariant;
    }()
  }, {
    key: "evalDivider",
    value: function () {
      var _evalDivider = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(catalog, rule, divider) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", new _promise["default"](function (resolve, reject) {
                _api.CrulesAPI.evalDivider(catalog, rule, divider, function (json) {
                  if (json) {
                    var newRule = new _classes.Rule(json);
                    rule.rows = newRule.rows;
                    rule.divset = newRule.divset;
                    rule.divider = newRule.divider;
                    rule.reg = newRule.reg;
                    resolve(newRule);
                  } else {
                    reject();
                  }
                }, function () {
                  reject();
                });
              }));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function evalDivider(_x9, _x10, _x11) {
        return _evalDivider.apply(this, arguments);
      }
      return evalDivider;
    }()
  }, {
    key: "evalCloset",
    value: function () {
      var _evalCloset = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(catalog, row, rule, closetData) {
        var placerIndex;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              placerIndex = -1;
              return _context7.abrupt("return", new _promise["default"](function (resolve, reject) {
                var ClonedRule = rule.clone();
                delete ClonedRule.rows;
                delete ClonedRule.extraEval;
                delete ClonedRule.agg;
                _api.CrulesAPI.evalCloset(catalog, ClonedRule, closetData, function (evalRes) {
                  if (evalRes) {
                    try {
                      if (placerIndex > -1) {
                        var ruleData = evalRes.rule;
                        if (ruleData && row.placer[placerIndex].rule) {
                          row.placer[placerIndex].rule.setVariantData(ruleData);
                        }
                      }
                      var newRule = new _classes.Rule(evalRes.rule);
                      var responseEval = new _classes.Eval3D(evalRes);
                      row.mergeEvalData(responseEval);
                      row.setRule(newRule);
                      resolve(responseEval);
                    } catch (err) {
                      reject(err);
                    }
                  } else {
                    reject();
                  }
                }, function () {
                  reject();
                });
              }));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function evalCloset(_x12, _x13, _x14, _x15) {
        return _evalCloset.apply(this, arguments);
      }
      return evalCloset;
    }()
  }, {
    key: "addGallery",
    value: function addGallery(json) {
      var jsonRows = json.autocompData.autoCompData.boxes;
      var oldUniqueIds = [];
      var newUniqueIds = [];
      for (var i = 0; i < jsonRows.length; i++) {
        var jsonRow = jsonRows[i].base.ruleRef.reference;
        oldUniqueIds.push(jsonRow.uniqueid);
        var prjRow = new _classes.ProjectRow(jsonRow);
        delete prjRow.uniqueid;
        var newRow = this.project.addNewRow();
        (0, _assign["default"])(newRow, prjRow);
        jsonRow.uniqueid = newRow.uniqueid;
        newUniqueIds.push(newRow.uniqueid);
      }
      for (var _i = 0; _i < newUniqueIds.length; _i++) {
        var actualRow = this.project.getRowByUid(newUniqueIds[_i]);
        var _jsonRow = jsonRows[_i].base.ruleRef.reference;
        if (actualRow.father != null || actualRow.father != undefined) {
          var iOf = (0, _indexOf["default"])(oldUniqueIds).call(oldUniqueIds, actualRow.father.idRow);
          if (iOf > -1) {
            actualRow.father.idRow = newUniqueIds[iOf];
            _jsonRow.father.idRow = newUniqueIds[iOf];
          }
        }
        for (var _i2 = 0; _i2 < actualRow.clPlacerChilds.length; _i2++) {
          var actualChild = actualRow.clPlacerChilds[_i2];
          var oldID = actualChild.idRow;
          var _iOf = (0, _indexOf["default"])(oldUniqueIds).call(oldUniqueIds, oldID);
          if (_iOf > -1) {
            _jsonRow.clPlacerChilds[_i2].idRow = newUniqueIds[_iOf];
            actualChild.idRow = newUniqueIds[_iOf];
          }
        }
      }
      json._newUniqueIds = newUniqueIds;
    }
  }, {
    key: "evalRow",
    value: function () {
      var _evalRow = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(row) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", _controllers.RowEval.eval(row));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function evalRow(_x16) {
        return _evalRow.apply(this, arguments);
      }
      return evalRow;
    }()
  }, {
    key: "calcReval",
    value: function () {
      var _calcReval = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(changes) {
        var _this4 = this;
        var forceHistory,
          _args9 = arguments;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              forceHistory = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : false;
              return _context9.abrupt("return", new _promise["default"](function (resolve, reject) {
                var data = _this4.project.getEvalProjectData(changes);
                _api.CrulesAPI.calcolaRivaluta(data, function (res) {
                  _this4.project.setEvalProjectData(res);
                  if (!changes.applyToSelected || forceHistory) {
                    if (changes.ruleTo && changes.ruleTo.reg) {
                      if (!changes.modelTo || !changes.modelTo.cmodel) {
                        var lastHistory = _this4.project.history[_this4.project.history.length - 1];
                        lastHistory.models[lastHistory.models.length - 1].header = changes.ruleTo.reg.replace(/\t/g, ';');
                        lastHistory.currentModel = lastHistory.models[lastHistory.models.length - 1];
                      } else {
                        changes.modelTo.header = changes.ruleTo.reg.replace(/\t/g, ';');
                        _this4.project.pushHistory(changes.catalog, changes.modelTo);
                      }
                    } else if (changes.modelTo && changes.modelTo.cmodel !== null) {
                      _this4.project.pushHistory(changes.catalog, changes.modelTo);
                    } else if (forceHistory) {
                      console.warn('Cannot force history of project without model');
                    }
                  }
                  resolve(res);
                }, reject);
              }));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function calcReval(_x17) {
        return _calcReval.apply(this, arguments);
      }
      return calcReval;
    }()
  }, {
    key: "reEvaluateFinals",
    value: function () {
      var _reEvaluateFinals = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        var _this5 = this;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", new _promise["default"](function (resolve, reject) {
                var data = _this5.project.getEvalProjectData();
                _api.CrulesAPI.jEvalTop2((0, _stringify["default"])(data), 1, 1, function (res) {
                  _this5.project.setEvalProjectData(res);
                  resolve(res);
                }, reject);
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function reEvaluateFinals() {
        return _reEvaluateFinals.apply(this, arguments);
      }
      return reEvaluateFinals;
    }()
  }, {
    key: "reEvaluateProject",
    value: function () {
      var _reEvaluateProject = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        var _this6 = this;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", new _promise["default"](function (resolve, reject) {
                var data = _this6.project.getEvalProjectData();
                for (var i = 0; i < data.rows.length; i++) {
                  data.rows[i].toreval = 2;
                }
                _api.CrulesAPI.calcolaRivaluta(data, function (res) {
                  _this6.project.setEvalProjectData(res);
                  resolve(res);
                }, reject);
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function reEvaluateProject() {
        return _reEvaluateProject.apply(this, arguments);
      }
      return reEvaluateProject;
    }()
  }, {
    key: "recomputePrices",
    value: function () {
      var _recomputePrices = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
        var _this7 = this;
        var replaceImages,
          _args12 = arguments;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              replaceImages = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : false;
              return _context12.abrupt("return", new _promise["default"](function (resolve, reject) {
                var data = _this7.project.getEvalProjectData();
                _api.CrulesAPI.calcolaRivaluta(data, function (res) {
                  _this7.project.setEvalProjectData(res);
                  switch (_this7.project.status.toLowerCase()) {
                    case 'unassigned':
                    case 'assigned':
                    case 'seller design':
                      var x = new Date();
                      _this7.project.priceDate = x.toInt();
                      break;
                  }
                  var encodePrj = _this7.project.getJson();
                  for (var i = 0; i < encodePrj.rows.length; i++) {
                    var r = encodePrj.rows[i];
                    encodePrj.rows[i] = {
                      uniqueid: r.uniqueid,
                      boxid: r.boxid,
                      catalog: r.catalog,
                      model: r.model,
                      cmodel: r.cmodel,
                      neutro: r.neutro,
                      erp: r.erp
                    };
                  }
                  _api.ProjectsAPI.recomputePrices(encodePrj, function (json) {
                    _this7.project.recompute(json, replaceImages);
                    resolve(json);
                  }, reject);
                }, reject);
              }));
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function recomputePrices() {
        return _recomputePrices.apply(this, arguments);
      }
      return recomputePrices;
    }()
  }, {
    key: "loadAllRowRules",
    value: function loadAllRowRules() {
      var _this8 = this;
      return new _promise["default"](function (resolve, reject) {
        var _context13;
        var rowsWithoutRule = (0, _filter["default"])(_context13 = _this8.project.rows).call(_context13, function (r) {
          return r.reg && !r.rule;
        });
        if (rowsWithoutRule.length) {
          _controllers.RowRule.loadRule(rowsWithoutRule[0]).then(_this8.loadAllRowRules)["catch"](reject);
        } else {
          resolve(null);
        }
      });
    }
  }]);
  return ProjectManager;
}();
exports.ProjectManager = ProjectManager;
//# sourceMappingURL=ProjectManager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/AppManager/ProjectManager.js
// module id = 469
// module chunks = 142